import { enUS, hy } from 'date-fns/locale';
import { forwardRef, useState } from 'react';
import { useGlobalState } from '../../App/globalState';
import { formatDate } from '../../Helpers/date-time-formatters';
import useTranslate from '../../Hooks/useTranslate';
import getTypographyConfig from '../typography-config';
import CalendarWrapper from './styles/calendarWrapper';

const Calendar = forwardRef((props, ref) => {
  const { selected, setSelected, endMonth, disabled } = props;
  const [selectedMonth, setSelectedMonth] = useState(new Date()); // currently displayed month
  const tr = useTranslate();

  const { globalState } = useGlobalState();
  const { language: selectedLanguage } = globalState || {};
  const validLanguages = [
    { key: 'en', calendarKey: enUS },
    { key: 'hy', calendarKey: hy },
  ];
  const calendarLanguage =
    validLanguages.find((l) => l.key === selectedLanguage)?.calendarKey || 'enUS';

  const today = new Date();
  const endOfYear = new Date(today.getFullYear(), 11, 31); // Dec 31

  const externalDisabled = [].concat(disabled || []);

  const typographyConfig = getTypographyConfig(selectedLanguage);

  const defaultProps = {
    mode: 'single',
    animate: true,
    navLayout: 'around',
    showOutsideDays: false,
    hideNavigation: false,
    disableNavigation: false,
    startMonth: today,
    endMonth: endMonth || endOfYear,
    locale: calendarLanguage,
    timeZone: 'Asia/Yerevan',
    weekStartsOn: 1, /// Monday

    selected,
    onSelect: setSelected,
    onMonthChange: setSelectedMonth,
    footer: selected
      ? `${tr('selected_date')} ${formatDate(selected)}`
      : tr('pick_a_day'),
  };

  const immutableProps = {
    numerals: 'latn',
    disabled: [
      { before: today },
      (date) => date.getMonth() !== selectedMonth.getMonth(),
      ...externalDisabled,
    ],
  };

  return (
    <CalendarWrapper
      $typography={typographyConfig}
      ref={ref}
      {...defaultProps}
      {...props}
      {...immutableProps}
    />
  );
});

Calendar.displayName = 'Calendar';
export default Calendar;
